import { combineReducers } from 'redux'
import { authentication, accessCode } from './authenticationReducer'
import { user } from './userReducer'
import { consultant } from './consultantReducer'
import { alert } from './alertReducer'
import { authConstants } from '../constants/actionTypes'
import { opportunity } from './opportunityReducer'
import { individualEstimate } from './individualEstimateReducer'
import { estimates } from './estimatesReducer'
import contactUsReducer from './contactUsReducer'
import proposalReducer from './proposalReducer'
import proceedEstimateReducer from './proceedEstimateReducer'
import applicationRolesReducer from './applicationRolesReducer'
import authReducer from './authReducer'
import { nextSteps } from './nextStepsReducer'
import { browser } from './browserReducer'
import emailReducer from './emailReducer'
import downloadPdfReducer from './downloadPdfReducer'
import captchaReducer from './captchaReducer'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { finAppStatus } from './finAppStatusReducer'
import { settlement } from './settlementReducer'

const allReducers = combineReducers({
  auth: authReducer,
  authentication,
  accessCode,
  user,
  consultant,
  alert,
  opportunity,
  individualEstimate,
  contactUs: contactUsReducer,
  estimates,
  nextSteps,
  browser,
  applicationRoles: applicationRolesReducer,
  proposal: proposalReducer,
  proceedEstimate: proceedEstimateReducer,
  email: emailReducer,
  downloadPdf: downloadPdfReducer,
  captcha: captchaReducer,
  finAppStatus,
  settlement,
})

const persistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'auth',
    'applicationRoles',
    'authentication',
    'browser',
    'consultant',
    'opportunity',
    'individualEstimate',
    'proposal',
    'user'
  ],
}

const rootReducer = (state, action) => {
  if (action.type === authConstants.LOGOUT  || action.type === authConstants.LOGIN_LOAD) {
    state = undefined
  }
  return allReducers(state, action)
}

export default persistReducer(persistConfig, rootReducer)
